<mat-icon *ngIf="showClear" (click)="clearInput()">clear</mat-icon>

